// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { BrandProvider } from "./hooks/useBranding";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import { DataProvider } from "./hooks/useData";
import { useMobile } from "./hooks/useMobile";
import Header from "./components/Header";
import Catalog from "./pages/public/Catalog";
import CategoryPage from "./pages/public/CategoryPage";
import { AboutUs, HowToOrder } from "./pages/public/AboutUs";
import SeoLandingPage from "./pages/public/SeoLandingPage";
import QuotationRequest from "./pages/public/QuotationRequest";
import Login from "./pages/admin/Login";
import DashboardRouter from "./pages/admin/DashboardRouter";
import { Spinner } from "./components/UI";
import NotificationPrompt from "./components/NotificationPrompt";

function ProtectedRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return <Spinner full />;
  return admin ? children : <Navigate to="/admin-login" replace />;
}

function AppContent() {
  const location = useLocation();
  const isMobile = useMobile();

  // Mobile dashboard has its own TopBar; the shared quotation link uses its
  // own focused, distraction-free layout.
  const isAdminDashboard = location.pathname === "/admin";
  const hideHeader = (isAdminDashboard && isMobile) || location.pathname === "/quotation-request";

  return (
    <div className="app-shell">
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/"               element={<Catalog />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/about"          element={<AboutUs />} />
        <Route path="/how-to-order"   element={<HowToOrder />} />
        <Route path="/kurti-manufacturer-ahmedabad" element={<SeoLandingPage />} />
        <Route path="/wholesale-kurtis-ahmedabad" element={<SeoLandingPage />} />
        <Route path="/cotton-kurtis-manufacturer" element={<SeoLandingPage />} />
        <Route path="/designer-kurtis-wholesale" element={<SeoLandingPage />} />
        <Route path="/quotation-request" element={<QuotationRequest />} />
        <Route path="/admin-login"    element={<Login />} />
        <Route path="/admin"          element={<ProtectedRoute><DashboardRouter /></ProtectedRoute>} />
        <Route path="*"               element={<Navigate to="/" replace />} />
      </Routes>

      {/* Notification prompt for public pages (not admin) */}
      {!isAdminDashboard && <NotificationPrompt />}
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrandProvider>
        <AuthProvider>
          <DataProvider>
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </DataProvider>
        </AuthProvider>
      </BrandProvider>
    </HelmetProvider>
  );
}
